import Contact from "../../../../content/pages/contact/contact";
import * as React from 'react';
export default {
  Contact,
  React
};